import React from 'react';
import {
  Box,
  Card,
  Spinner,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

type Props = {
  actionButton?: React.ReactElement,
  message: string,
  error?: string,
};

const LoadingScreen = ({ actionButton, message, error }: Props) => {
  return (
    <>
      <Spinner
        sx={{
          height: '100vh',
          width: '100%',
          position: 'fixed',
          zIndex: 1,
          display: error ? 'none' : undefined,
        }}
      />
      <Box
        sx={{
          height: '100vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          transition: ({ transitions }) =>
            transitions.create('backdrop-filter', {
              duration: transitions.duration.standard,
              easing: transitions.easing.easeIn,
            }),
          backdropFilter: `blur(${error ? 5 : 1}px)`,
        }}
      >
        <Card
          raised={!!error}
          sx={{
            p: 2,
            transition: ({ transitions }) =>
              transitions.create('opacity', {
                duration: transitions.duration.enteringScreen,
                easing: transitions.easing.easeIn,
              }),
            opacity: error ? 0.9 : 0,
          }}
        >
          <Typography
            variant="h2"
            color={error ? 'error' : undefined}
            paragraph
          >
            {error ? 'Error' : message}
          </Typography>
          {error && (
            <Typography maxWidth={350} variant="caption" paragraph>
              {error}
            </Typography>
          )}
          {error && actionButton !== undefined && actionButton}
        </Card>
      </Box>
    </>
  );
};

LoadingScreen.defaultProps = {
  actionButton: undefined,
  error: undefined,
};

export default LoadingScreen;
